const Main = () => import('@/views/main');
const HomePage = () => import('@/views/home');

export default [{
    path: '/home',
    name: 'home',
    component: Main,
    redirect: '/homePage',
    meta: {
        name: '首页',
        unfold: false,
        iconType: "",
    },
    children: [{
        path: '/homePage',
        name: 'homePage',
        component: HomePage,
        meta: {
            name: '首页'
        },
    }]
}]